import { __decorate } from "tslib";
// components
import scrollama from 'scrollama';
import './components/us-campaign/logo-band';
import './components/us-campaign/campaign-section';
import './components/us-campaign/campaign-section-etf';
import './components/us-campaign/campaign-section-canvas-nobg';
import './components/us-campaign/campaign-section-digital-assets';
import './components/us-campaign/campaign-section-power-partnership';
import './components/us-campaign/campaign-section-relationships';
import './components/us-campaign/us-campaign-footer';
import { html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { USBrandCampaign } from './common/us-branding';
function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function (...args) {
        const context = this;
        const now = Date.now();
        if (!lastRan) {
            func.apply(context, args);
            lastRan = now;
        }
        else {
            clearTimeout(lastFunc);
            lastFunc = window.setTimeout(function () {
                if (now - lastRan >= limit) {
                    func.apply(context, args);
                    lastRan = now;
                }
            }, limit - (now - lastRan));
        }
    };
}
let CampaignController = class CampaignController extends USBrandCampaign {
    constructor() {
        super();
        this.scrollMilestones = {
            25: false,
            50: false,
            75: false,
            95: false,
        };
        //private scrollMilestonesAfterEngagemnentTimer: Record<25 | 50 | 75 | 95, boolean> = {
        this.scrollMilestonesAfterEngagemnentTimer = {
            //25: false,
            //50: false,
            75: false
            //95: false,
        };
        this.oneMinuteEngagement = false;
        //@property({ type: String })
        this.section = "1";
        window.dataLayer = window.dataLayer || [];
        this.track({ page_data: null });
        this.track({
            "event": "page_load_started",
            "detailed_event": "Page Load Started",
            "page_data": {
                "language": "en",
                "language_code": "en-us",
                "page_title": document.title,
                "page_type": "campaign",
            },
            "language": "en",
            "language_code": "en-US",
            "page_title": document.title,
            "page_type": "campaign",
        });
        this._onScroll = throttle(this._onScroll.bind(this), 50);
        setTimeout(() => {
            this.oneMinuteEngagement = true;
            const scrollTop = window.scrollY;
            const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercentage = (scrollTop / pageHeight) * 100;
            this._checkEngagementScrollMilestone(scrollPercentage);
        }, 60000);
    }
    checkFP() {
        return false;
        const checkFP = document.cookie.split(';').filter(cookie => cookie.trim() === 'user_role=financial-professionals');
        if (checkFP.length > 0) {
            return true;
        }
        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (params.get('role-type') === 'fp') {
            return true;
        }
        return false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.shadowRoot.addEventListener('ft.navigate', this._handleEvent.bind(this));
        window.addEventListener('scroll', this._onScroll);
        window.addEventListener('message', this._onMessage);
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('message', this._onMessage);
        this.shadowRoot.removeEventListener('ft.navigate', this._handleEvent);
    }
    requestUpdate(name, oldValue) {
        return super.requestUpdate(name, oldValue);
    }
    updated(_changedProperties) {
        setTimeout(() => {
            const scroller = scrollama();
            scroller
                .setup({
                step: '.step',
                parent: this.shadowRoot,
                progress: true
            }).onStepEnter((response) => {
                response.element.setAttribute('seen', 'true');
                this.section = (response.index).toString();
            }).onStepExit((response) => {
            }).onStepProgress((response) => {
                response.element.setAttribute('progress', response.progress.toString());
            });
        }, 1000);
    }
    _goToTop(e) {
        e.preventDefault();
        this._navigateTo(0);
    }
    _nextSection(e) {
        e.preventDefault();
        this._navigateTo(Number(this.section) + 1);
        this.section = (Number(this.section) + 1).toString();
    }
    _previousSection(e) {
        e.preventDefault();
        this._navigateTo(Number(this.section) - 0);
    }
    /**
     * Navigate to a page section
     * @param section The section number
     */
    _navigateTo(section, subElement) {
        let element = this.shadowRoot.querySelector(`[data-scrollama-index="${section}"]`);
        let y = 0;
        if (element) {
            if (subElement) {
                const subElementInParent = element.shadowRoot.querySelector(subElement);
                if (subElementInParent) {
                    element = subElementInParent;
                }
            }
            y = element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }
    /**
     * Handles section navigation
     * @param event The Custom Event
     */
    _handleEvent(event) {
        if (event.detail.element) {
            this._navigateTo(Number(event.detail.section), event.detail.element);
        }
        else {
            this._navigateTo(Number(event.detail.section));
        }
    }
    _onMessage(event) {
        const eventData = event.data;
        /**
         * Filer out only 'Video' related event and push it to 'dataLayer' array
         */
        if (eventData.hasOwnProperty('videoCategory')) {
            this.track(eventData);
        }
    }
    _onScroll(event) {
        const scrollTop = window.scrollY;
        const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentage = (scrollTop / pageHeight) * 100;
        if (scrollPercentage < 50) {
            let inner = this.shadowRoot.querySelector('.inner-campaign');
            inner.style.backgroundPositionY = `-${(scrollPercentage) * 1.75}%`;
        }
        this._checkScrollMilestone(scrollPercentage);
        this._checkEngagementScrollMilestone(scrollPercentage);
    }
    _checkScrollMilestone(scrollPercentage) {
        const milestones = [25, 50, 75, 95];
        for (const milestone of milestones) {
            if (scrollPercentage >= milestone && !this.scrollMilestones[milestone]) {
                this.scrollMilestones[milestone] = true;
                this.track({
                    event: 'scroll_depth',
                    action: `${milestone === 95 ? '100' : milestone}%`,
                    detailed_event: 'Scroll Depth Tracking',
                    event_data: {
                        milestone: `${milestone === 95 ? '100' : milestone}%`,
                    },
                });
            }
        }
    }
    _checkEngagementScrollMilestone(scrollPercentage) {
        //const milestones: Array<25 | 50 | 75 | 95> = [25, 50, 75, 95];
        const milestones = [75];
        if (!this.oneMinuteEngagement) {
            return;
        }
        for (const milestone of milestones) {
            if (scrollPercentage >= milestone && !this.scrollMilestonesAfterEngagemnentTimer[milestone]) {
                this.scrollMilestonesAfterEngagemnentTimer[milestone] = true;
                this.track({
                    event: 'read_content',
                    //action: `1 Minute and ${milestone === 95 ? '100' : milestone}% Scroll`,
                    action: `1 Minute and ${milestone}% Scroll`,
                    detailed_event: 'Read Content',
                    event_data: {
                        //page_engagement_type: `1 Minute and ${milestone === 95 ? '100' : milestone}% Scroll`
                        page_engagement_type: `1 Minute and ${milestone}% Scroll`
                    }
                });
            }
        }
    }
    render() {
        return html `
        <div class="scroll-nav">
          <a href="#" @click="${this._nextSection}">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.63672C12.4142 2.63672 12.75 2.97251 12.75 3.38672L12.75 19.5761L18.9697 13.3564C19.2626 13.0635 19.7374 13.0635 20.0303 13.3564C20.3232 13.6493 20.3232 14.1242 20.0303 14.417L12.5303 21.917C12.2374 22.2099 11.7626 22.2099 11.4697 21.917L3.96967 14.417C3.67678 14.1242 3.67678 13.6493 3.96967 13.3564C4.26256 13.0635 4.73744 13.0635 5.03033 13.3564L11.25 19.5761L11.25 3.38672C11.25 2.97251 11.5858 2.63672 12 2.63672Z" fill="#ffffff"/>
            </svg>
          </a>
        </div>
      <div class="campaign-section-container" style="display: block; position: relative">      
           <div class="inner-campaign">
            <campaign-section 
              class="step step-space"></campaign-section>
            <campaign-section-digital-assets 
              class="step step-space"></campaign-section-digital-assets>
            <campaign-section-canvas-nobg 
              class="step step-space"></campaign-section-canvas-nobg>
            <campaign-section-etf 
              class="step step-space"></campaign-section-etf>
            <campaign-section-power-partnership 
              class="step"></campaign-section-power-partnership>
            <campaign-section-relationships 
              class="step"></campaign-section-relationships>      
          </div>
        </div>        
      
        <slot></slot>
      `;
    }
};
CampaignController.styles = [
    css `
        .scroll-nav {
          position: fixed;
          bottom: 1px;
          z-index: 10;
          margin: 0 auto;
          display: block;
          width: 100%;
          text-align: center;          
          display: none;
        }

        a {
          font-size: 2rem;
          text-decoration: none;
          color: rgba(255, 255, 255, .6);

          & svg {
            transition: all .2s ease-in-out;
          }
          & svg:hover {
            transform: scaleY(1.8) scaleX(1.3);
         }           
        }

        @media (min-width: 768px) {
          .step-space {
            padding: 0rem 0 6rem;
            background: linear-gradient(90deg, rgba(0,30,98,1) 0%, rgba(20,70,225,1) 40%, rgba(87,30,220,0) 100%);
          }
        }

        @media (min-width: 1200px) {
          .step-space {
            padding: 0rem 0 10rem;
            background: transparent;
          }
        }        

        .hidden {
          display: none;
        }

        :host {
            display: block;
            position: relative;
            z-index: 0;
            background: rgb(0,30,98);
            background: linear-gradient(90deg, rgba(0,30,98,1) 0%, rgba(20,70,225,1) 78%, rgba(87,30,220,1) 100%);            
        }


        .inner-campaign {
          position: relative; 
          padding: 0; 
          width: 100%; 
          margin: 0 auto; 
          scroll-snap-type: y proximity; 
          padding-top: 1rem; 
        }

        @media (min-width: 768px) {
          .inner-campaign {
            padding-top: 0rem;             
            background: url(./assets/images/confetti-2.png) no-repeat right 0%;
            transition: background-position-y ease-out .5s;
          }
        }

        @keyframes scale-in-ver-top {
          0% {
              transform: scaleY(0);
              transform-origin: 100% 0%;
              opacity: 1;
          }
          100% {
              transform: scaleY(1);
              transform-origin: 100% 0%;
              opacity: 1;
          }
      }             

      `
];
CampaignController = __decorate([
    customElement('campaign-controller')
], CampaignController);
//# sourceMappingURL=main.js.map